<!-- Read-only (CONTRACT-v1.4 §9): add-ons are sold or comped under Modules, prices and allowances under Billing, the switch under AI › Images. -->
<section class="panel">
  <div class="section-header">
    <h3>AI images</h3>
    @if (imageAddOns.length) {
      <span class="pill pill-purple pill-sm">add-on</span>
    } @else {
      <span class="pill pill-grey pill-sm" title="Without the add-on the Create tab and the agent opt-in are shown locked">locked</span>
    }
  </div>

  <div class="kv">
    <div class="kv-row add-ons-row">
      <span class="k">Add-on</span>
      <span class="v">
        @for (a of imageAddOns; track a.userPlanAddOnId) {
          <span class="add-on">
            {{ a.planName }}@if (addOnAllowance(a); as n) { <span class="muted"> · {{ n }} a month</span> }<span class="muted"> · {{ a.isGranted ? 'Comped' : 'Purchased' }}</span>
          </span>
        } @empty {
          <span class="muted">None — the owner has not added AI images</span>
        }
      </span>
    </div>
  </div>

  @if (loading) {
    <span class="muted">Loading image usage…</span>
  } @else if (unavailable) {
    <span class="muted">{{ unavailable }}</span>
  } @else if (error) {
    <span class="muted">{{ error }}</span>
  } @else if (usage) {
    <div class="tiles">
      <div class="tile"><div class="k">Allowance</div><div class="v allowance">{{ usage.allowance }}</div></div>
      <div class="tile"><div class="k">Used</div><div class="v used">{{ usage.used }}</div></div>
      <div class="tile"><div class="k">Reserved</div><div class="v reserved">{{ usage.reserved }}</div></div>
      <div class="tile"><div class="k">Left</div><div class="v left" [class.over]="exhausted">{{ usage.left }}</div></div>
      <div class="tile" title="What the month's requests cost Plus at the provider, refusals included — never shown to owners">
        <div class="k">Our cost ({{ monthName }})</div><div class="v cost">{{ usd(costUsd) }}</div>
      </div>
    </div>

    @if (usedPct !== null) {
      <div class="meter" role="progressbar" aria-label="Allowance used or reserved" [attr.aria-valuenow]="usedPct" aria-valuemin="0" aria-valuemax="100">
        <div class="meter-fill" [class.over]="exhausted" [style.width.%]="usedPct"></div>
      </div>
    }
    @if (usage.resetsAtUtc) {
      <p class="muted note-line">Shared by every business of the owner's account · resets {{ usage.resetsAtUtc | date:'d MMM y':'UTC' }} (UTC).</p>
    }

    @if (!generations.length) {
      <p class="muted empty-line">No image requests this month.</p>
    } @else {
      <div class="tbl-wrap gen-tbl">
        <table class="tbl">
          <thead>
            <tr>
              <th>Images</th>
              <th>At</th>
              <th>Purpose</th>
              <th>Status</th>
              <th class="num">Counted</th>
              <th class="num">Cost</th>
              <th>Who</th>
              <th>Model</th>
            </tr>
          </thead>
          <tbody>
            @for (g of generations; track g.generationId) {
              <tr class="gen-row" [attr.data-generation]="g.generationId">
                <td class="thumbs">
                  @for (t of thumbs(g); track t.mediaId) {
                    <img [src]="t.url" [alt]="'Candidate ' + t.mediaId" loading="lazy" width="48" height="32" />
                  } @empty {
                    <span class="muted">—</span>
                  }
                </td>
                <td class="mono when" [title]="g.reservedAt">{{ utc(g.reservedAt) | date:'d MMM HH:mm':'UTC' }}</td>
                <td>
                  {{ purpose(g.purpose) }}@if (slot(g.slotKey); as s) { <span class="muted"> · {{ s }}</span> }
                </td>
                <td><span [class]="statusPill(g.status) + ' pill-sm'">{{ statusLabel(g) }}</span></td>
                <td class="num">{{ counted(g) }}<span class="muted"> / {{ g.requested }}</span></td>
                <td class="num mono">{{ usd(g.costUsd) }}</td>
                <td class="who">{{ who(g.requestedBy) }}</td>
                <td class="mono">{{ g.providerModel || '—' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  }

  <p class="muted note-line">
    Read-only. Costs are Plus's provider cost in USD and the model is ours to choose; owners never see either.
    Creating images is switched on and off for every business under <a routerLink="/ai/images">AI › Images</a>.
  </p>
</section>
